import { useState } from "react";
import { LoginValues } from "../loginTypes";
import CustomInput from "../../../../components/custom/input";
import CustomButton from "../../../../components/custom/button";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import { loginVerifyOTPAsync } from "../../../../../app/slices/loginSlice/loginSlice";
import { otpValidation } from "../loginValidation";
import { showSnackbar } from "../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import {
  setSession,
  getDecryptedToken,
} from "../../../../../app/auth/authHandler";
import { useNavigate } from "react-router-dom";
import {
  getProfileDataAsync,
  setUserDetails,
  setValidUser,
} from "../../../../../app/slices/profileSlice/ProfileSlice";

const VerifyOtp = ({ mobileNumber, onClose, isFromAccount }: LoginValues) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const veriFySelector = useAppSelector((state: any) => state.login.verify);

  const initialState: LoginValues = {
    otp: null,
  };

  const [otpverifyData, setOtpVerifyData] = useState(initialState);
  const [errors, setErrors] = useState<Partial<LoginValues>>({});

  const verifyOTPFn = () => {
    const errorCheck = otpValidation(otpverifyData);

    if (Object.keys(errorCheck).length === 0) {
      const payload: any = {
        mobile_number: mobileNumber?.replace(" ", ""),
        OTP: Number(otpverifyData?.otp),
        fcm_token: localStorage.getItem("FCM_TOKEN"),
      };
      const aId = localStorage.getItem("aId");
      const accessToken = getDecryptedToken();
      const anonymous_id: any = accessToken ? null : aId ? aId : null;
      if (anonymous_id) {
        payload.anonymous_id = anonymous_id;
      }

      dispatch(loginVerifyOTPAsync(payload)).then((resolve: any) => {
        if (resolve.payload?.status === 200) {
          setSession(resolve.payload.data.jwt_token);
          localStorage.removeItem("aId");
          // const user = decodeToken(resolve.payload.data.jwt_token);
          dispatch(
            showSnackbar({
              message: "You’ve successfully logged in!",
              severity: "success",
              autoHide: 2000,
            })
          );

          if (isFromAccount) {
            dispatch(getProfileDataAsync()).then((response: any) => {
              if (response?.payload?.status === 200) {
                const ResponseData = response?.payload?.data?.data;

                dispatch(setUserDetails(ResponseData));
                dispatch(setValidUser(true));
              }
            });
            navigate("/checkout");
            onClose();
          } else {
            window.location.href = "/";
          }
        } else {
          setSession("");
          dispatch(
            showSnackbar({
              message: "Please try again .",
              severity: "error",
              autoHide: 1000,
            })
          );
        }
      });
    } else {
      setErrors(errorCheck);
    }
  };
  const onValidate = () => {
    return true;
  };
  const inputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    let curErrors: any = { ...errors };
    delete curErrors[name];
    setErrors(curErrors);
    setOtpVerifyData({
      ...otpverifyData,
      [name]: value,
    });
  };

  return (
    <>
      {" "}
      <div className="tf-field style-1 mb_30">
       <CustomInput
        name="otp"
        type="number"
        label="One time password"
        onChange={inputChange}
        error={!!errors?.otp}
        fullWidth
        helperText={errors?.otp}
        value={otpverifyData?.otp}
      />
      </div>
      <CustomButton
        name="Verify OTP"
        size="large"
        fullWidth
        loader={veriFySelector.loader}
        onClick={verifyOTPFn}
      />
    </>
  );
};

export default VerifyOtp;
